import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-solar-procedure',
  templateUrl: './solar-procedure.component.html',
  styleUrls: ['./solar-procedure.component.scss']
})
export class SolarProcedureComponent implements OnInit {
  @ViewChild('queryDataTable', { static: true })
  public queryDataTable: Table;
  
  public userId: any;
  public procedureName: any;
  public parameters: any;
  public password: any;

  public tableData: any = [];
  public tableColumns: any = [];

  constructor(
    private cryptoJsService: CryptoJsService, 
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private apiService: DashboardService,
  ) { }


  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    // console.log('token1', token);
    // this.vendorRegId = JSON.stringify(token?.officeCode);
    // console.log('officeCode', this.vendorRegId);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

  }

  onSubmit() {
    if(this.procedureName == null || this.procedureName == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please write a procedure.',
      });
      return;
    }
    // if(this.parameters == null || this.parameters == ""){
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error Message',
    //     detail: 'Please Enter Parameters.',
    //   });
    //   return;
    // }
    if(this.password == null || this.password == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please Enter Password.',
      });
      return;
    }
    let reqBody = {
      procName: this.cryptoJsService.Encrypt(this.procedureName),
      parameter: this.cryptoJsService.Encrypt(this.parameters),
      userId: this.userId ? this.cryptoJsService.Encrypt(this.userId) : '',
      passCode: this.cryptoJsService.Encrypt(this.password)
    }
    this.postQuery(reqBody);
  }


  postQuery(reqBody){
    this.loader.start();
    this.apiService
      .solarProcedure(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.procedureName = null;
          // this.parameters = null;
          this.password = null;
          
          
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: JSON.stringify(data),
          });
          
          this.tableColumns = Object.keys(data[0])
          this.tableData = data;
        },
        error: (err) => {
          this.loader.close();
          this.tableColumns = [];
          this.tableData = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }


}
